/* Shared P1 guide controller. Each installation route owns its steps and IDs. */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.p1Ready) return;
    const steps = Array.from(root.querySelectorAll('[data-p1-step]'));
    if (!steps.length) return;
    const select = root.querySelector('[data-p1-select]');
    const navLinks = Array.from(root.querySelectorAll('.zv-p1-solo__step-nav [data-p1-go]'));
    const navViewport = root.querySelector('.zv-p1-solo__nav-scroll');
    const progress = root.querySelector('[data-p1-progress]');
    const bar = root.querySelector('[data-p1-progress-bar]');
    const phase = root.querySelector('[data-p1-phase]');
    const counter = root.querySelector('[data-p1-counter]');
    const prev = root.querySelector('[data-p1-prev]');
    const next = root.querySelector('[data-p1-next]');
    const finish = root.querySelector('[data-p1-finish]');
    const allButton = root.querySelector('[data-p1-all]');
    const controls = root.querySelector('[data-p1-controls]');
    const announce = root.querySelector('[data-p1-announcement]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0;
    let showAll = true;
    const available = function () { return !root.closest('[hidden]'); };
    const hashIndex = function () {
      return steps.findIndex(function (step) { return '#' + step.id === window.location.hash; });
    };
    function display(index, options) {
      options = options || {};
      active = Math.max(0, Math.min(steps.length - 1, Number(index) || 0));
      steps.forEach(function (step, i) { step.hidden = !showAll && i !== active; });
      navLinks.forEach(function (link, i) {
        if (i === active) link.setAttribute('aria-current', 'step');
        else link.removeAttribute('aria-current');
      });
      if (navViewport && navViewport.clientHeight && navLinks[active]) {
        const item = navLinks[active].getBoundingClientRect();
        const viewport = navViewport.getBoundingClientRect();
        if (item.top < viewport.top + 6) navViewport.scrollTop += item.top - viewport.top - 6;
        else if (item.bottom > viewport.bottom - 6) navViewport.scrollTop += item.bottom - viewport.bottom + 6;
      }
      select.value = String(active);
      progress.textContent = window.ZinVoltI18n.t("step_progress", {current:active + 1,total:steps.length});
      bar.value = active + 1;
      phase.textContent = steps[active].dataset.p1PhaseName;
      counter.textContent = (active + 1) + ' / ' + steps.length;
      prev.disabled = active === 0;
      next.hidden = active === steps.length - 1;
      finish.hidden = active !== steps.length - 1;
      controls.hidden = showAll;
      allButton.setAttribute('aria-pressed', String(showAll));
      allButton.textContent = showAll ? window.ZinVoltI18n.t("show_one_step_at_a_time_c44cdb") : window.ZinVoltI18n.t("show_all_steps_3849ac");
      root.dataset.p1Mode = showAll ? 'all' : 'single';
      if (options.history) {
        const url = new URL(window.location.href);
        url.hash = steps[active].id;
        if (url.href !== window.location.href) window.history.pushState(null, '', url);
      }
      if (options.focus) {
        const heading = steps[active].querySelector('h2');
        heading.focus({ preventScroll: true });
        steps[active].scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        announce.textContent = window.ZinVoltI18n.t("step_current_of_total_title_b59153", {current:active + 1,total:steps.length,title:heading.textContent});
      }
    }
    function go(index) {
      display(index, { history: true, focus: true });
    }
    root.addEventListener('click', function (event) {
      const goLink = event.target.closest('[data-p1-go]');
      if (goLink && root.contains(goLink)) {
        event.preventDefault();
        go(Number(goLink.dataset.p1Go));
        return;
      }
    });
    prev.addEventListener('click', function () { go(active - 1); });
    next.addEventListener('click', function () { go(active + 1); });
    select.addEventListener('change', function () { go(Number(select.value)); });
    allButton.addEventListener('click', function () {
      showAll = !showAll;
      display(active, { focus: true });
      announce.textContent = showAll ? window.ZinVoltI18n.t("all_steps_are_visible_1fe920") : window.ZinVoltI18n.t("one_step_is_visible_at_a_time_d24c9e");
    });
    function restoreLocation() {
      if (!root.dataset.p1Route && available() && (!window.location.hash || hashIndex() >= 0)) {
        display(hashIndex(), { focus: hashIndex() >= 0 });
      }
    }
    window.addEventListener('popstate', restoreLocation);
    window.addEventListener('hashchange', restoreLocation);
    root.addEventListener('shopify:block:select', function (event) {
      const step = event.target.closest('[data-p1-step]');
      if (step) go(steps.indexOf(step));
    });
    root.addEventListener('p1:activate', function (event) {
      if (event.detail.reset) showAll = true;
      display(event.detail.index || 0, { focus: event.detail.focusStep === true });
    });
    let scrollQueued = false;
    window.addEventListener('scroll', function () {
      if (!showAll || scrollQueued || !available()) return;
      scrollQueued = true;
      window.requestAnimationFrame(function () {
        scrollQueued = false;
        if (!showAll || !available()) return;
        let index = 0;
        steps.forEach(function (step, i) { if (step.getBoundingClientRect().top <= 180) index = i; });
        if (index !== active) display(index);
      });
    }, { passive: true });
    root.dataset.p1Ready = 'true';
    allButton.hidden = false;
    controls.hidden = false;
    display(hashIndex(), { focus: !root.dataset.p1Route && available() && hashIndex() >= 0 });
  }
  function initAll(context) {
    if (context.matches && context.matches('[data-p1-guide]')) init(context);
    context.querySelectorAll('[data-p1-guide]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
